const n = "_info_aau4f_1", o = "_hasLeftComponent_aau4f_7", t = "_hasLeftComponentAndNoDescription_aau4f_10", e = "_textContainer_aau4f_14", a = "_noThumbnail_aau4f_18", i = "_headerContainer_aau4f_22", s = {
  info: n,
  hasLeftComponent: o,
  hasLeftComponentAndNoDescription: t,
  textContainer: e,
  noThumbnail: a,
  headerContainer: i
};
export {
  s as default,
  o as hasLeftComponent,
  t as hasLeftComponentAndNoDescription,
  i as headerContainer,
  n as info,
  a as noThumbnail,
  e as textContainer
};
//# sourceMappingURL=index.es5844.js.map
